<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import TableCell from "@/components/global-themed/table/TableCell.vue";
import TableRow from "@/components/global-themed/table/TableRow.vue";
import moment from "moment";
import Swal from "sweetalert2";
import {useAnnotationMutations} from "@/composables/admin/useSeoScoreAnnotations";

const props = defineProps({
  annotation: {
    required: true,
    type: Object,
  },
});

const emit = defineEmits(['edit']);

const {deleteAnnotationMutation} = useAnnotationMutations();

const formattedDate = moment(props.annotation.date).format('MMM DD, YYYY');

const handleEdit = () => {
  emit('edit', props.annotation);
};

const handleDelete = () => {
  Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
  }).then((result) => {
    if (result.isConfirmed) {
      deleteAnnotationMutation.mutate(props.annotation.id);
    }
  });
};
</script>

<template>
  <TableRow>
    <TableCell
      col-span="3"
      class="tw-flex tw-space-x-4 tw-items-center"
    >
      {{ annotation.title }}
    </TableCell>

    <TableCell
      col-span="2"
      class="tw-flex tw-space-x-4 tw-items-center"
    >
      {{ formattedDate }}
    </TableCell>

    <TableCell
      col-span="5"
      class="tw-flex tw-space-x-4 tw-items-center"
    >
      <span class="tw-line-clamp-2">{{ annotation.description }}</span>
    </TableCell>

    <TableCell
      class="tw-flex tw-gap-2 tw-justify-center"
      col-span="2"
    >
      <DefaultButton
        variant="primary-inverted"
        class="!tw-py-2 !tw-px-4 !tw-rounded-lg tw-h-10"
        @click="handleEdit"
      >
        <svg-vue
          icon="icons/pen"
          class="tw-w-6 tw-h-6"
        />
        <span class="tw-font-semibold tw-antialiased">Edit</span>
      </DefaultButton>

      <DefaultButton
        variant="danger"
        class="!tw-py-2 !tw-px-4 !tw-rounded-lg tw-h-10"
        @click="handleDelete"
      >
        <svg-vue
          icon="icons/trash"
          class="tw-w-6 tw-h-6"
        />
        <span class="tw-font-semibold tw-antialiased">Delete</span>
      </DefaultButton>
    </TableCell>
  </TableRow>
</template>
